export default "__VITE_ASSET__BuhE38N7__";